import React, { useState } from 'react';
import { Button, Box, TextField, Typography } from '@mui/material';
import { SelectStation } from './SelectStation';
import { SelectLine } from './SelectLine';
import type {
  StationWithLine,
  StationMaster,
  LineMaster,
} from '../../types/station/station';
import type { SelectLineStationType } from '../pages/Home';

type SelectLineStationProps = {
  selectedList: SelectLineStationType[];
  setSelectedList: React.Dispatch<
    React.SetStateAction<SelectLineStationType[]>
  >;
  debug?: boolean;
};

export const SelectLineStation = ({
  selectedList,
  setSelectedList,
  debug = false,
}: SelectLineStationProps) => {
  // 駅を追加
  const addStation = () => {
    setSelectedList([...selectedList, { station: undefined }]);
  };

  // 駅を削除
  const deleteStation = (stationCode: string) => {
    // setSelectedList(selectedList.filter((s) => s.stationCode !== stationCode));
  };

  // 駅を更新
  const updateStation = (selectedStation: StationWithLine, index: number) => {
    setSelectedList((prev) => {
      const result = [...prev];
      result[index].station = selectedStation;
      return result.filter(
        (item) => item != null && (item?.line || item?.station)
      );
    });
  };

  // 路線を更新
  const updateLine = (selectedLine: LineMaster, index: number) => {
    setSelectedList((prev) => {
      const result = [...prev];
      result[index].line = selectedLine;
      result[index + 1] = { station: undefined, line: undefined };
      return result;
    });
  };

  const checkAbleInput = (index: number) => {
    const list = selectedList.filter((item) => item != null);
    if (!index && list.length === 1 && !list?.[0]?.line) {
      return true;
    }
    if (index && !list?.[index]?.line) {
      return true;
    }
    return false;
  };

  return (
    <Box sx={{ width: 500, display: 'flex', flexDirection: 'column', gap: 2 }}>
      {debug && <p>{JSON.stringify(selectedList)}</p>}
      {debug && (
        <>
          <div>
            <TextField rows={8} />
          </div>
          <div>
            <Button onClick={() => {}}>反映</Button>
          </div>
        </>
      )}
      {selectedList.map(({ station }, index) => (
        <React.Fragment
          // keyで並べるしかないので無効化。
          // eslint-disable-next-line react/no-array-index-key
          key={`
            ${station?.stationCode ?? 's'}${
            station?.lines?.[0]?.lineCode ?? 'l'
          }-${index}
          `}
        >
          {(!index || selectedList?.[index - 1]?.line) && (
            <>
              <SelectStation
                key={station?.stationCode ?? 'ns'}
                selectedStation={station}
                selectedList={selectedList}
                setSelectedStation={(selectedStation) =>
                  updateStation(selectedStation, index)
                }
                index={index}
                line={index > 0 ? selectedList[index - 1].line : undefined}
                readOnly={!checkAbleInput(index)}
              />
            </>
          )}
          {station && (
            <SelectLine
              index={index}
              selectedList={selectedList}
              lines={station?.lines}
              setSelectedLine={(selectedLine) =>
                updateLine(selectedLine, index)
              }
              readOnly={
                (!selectedList[selectedList.length - 1].station &&
                  index < selectedList.length - 2) ||
                (selectedList[selectedList.length - 1].station &&
                  index !== selectedList.length - 1)
              }
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};
